import React, { useState } from "react";
import { Column } from "react-data-grid";
import { ServiceObjectTableQuery } from "../../../serviceObjects/models";
import { useCustomTranslation } from "../../../../helpers/translateHelpers";
import { Table, Title } from "../../../../components";
import { getTablePageCount } from "../../../../helpers/tableHelpers";
import { useGetServiceObjectsQuery } from "../../../serviceObjects/queries";
import { useNavigate } from "../../../../helpers/navigationHelpers";
import { renderDate } from "../../../../helpers/dayjsHeleprs";
import { CPOrderDetail, CPServiceObject } from "../../../../api/models/unified";

interface Props {
  orderDetail: CPOrderDetail;
}

const defaultTableQuery: ServiceObjectTableQuery = {
  page: 1,
  pageSize: 10,
};

const OrderServiceObjectsTable: React.FC<Props> = (
  props,
): React.ReactElement => {
  const { orderDetail } = props;
  const { tServiceObject, tOrder } = useCustomTranslation();
  const navigate = useNavigate();

  const [queryParams, setQueryParams] = useState<ServiceObjectTableQuery>({
    ...defaultTableQuery,
    orderId: orderDetail.id,
  });

  const query = useGetServiceObjectsQuery(queryParams);

  const columns: Column<CPServiceObject>[] = [
    {
      key: "name",
      name: tServiceObject("name"),
      sortable: true,
    },
    {
      key: "categoryName",
      name: tServiceObject("category"),
      sortable: true,
    },
    {
      key: "manufacturerName",
      name: tServiceObject("manufacturer"),
      sortable: true,
    },
    {
      key: "identificationNumber",
      name: tServiceObject("identification_number"),
      sortable: true,
    },
    {
      key: "location",
      name: tServiceObject("location"),
      sortable: true,
    },
    {
      key: "nextRevision",
      name: tServiceObject("next_revision"),
      renderCell: ({ row }) => renderDate(row.nextRevision),
      sortable: true,
    },
  ];

  return (
    <div className="mt-14">
      <Title className="mb-2.5 ml-5" title={tOrder("serviceObjects")} />
      <Table
        columns={columns}
        data={query.data?.data ?? []}
        loading={query.isLoading}
        queryParams={queryParams}
        onTableQueryChange={setQueryParams}
        pageCount={getTablePageCount(
          query.data?.total ?? 1,
          queryParams.pageSize,
        )}
        detailMode
        onRowClick={(item) => navigate.goTo(`serviceObjects/${item.id}`)}
      />
    </div>
  );
};

export default OrderServiceObjectsTable;
